






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PreliminaryReportModel from "@/model/PreliminaryReport";
import BaseCurrency from "@/components/Base/Controls/BaseCurrency.vue";

const AppStore = namespace("App");
const FormStore = namespace("Form");

@Component({
  name: "PreliminaryReportRND",
  components: {
    BaseCurrency
  }
})
export default class PreliminaryReportRND extends Vue {
  @Prop({ required: true })
  readonly value!: PreliminaryReportModel;

  private report: PreliminaryReportModel | null = this.value;

  @FormStore.State
  formDisabled!: boolean;

  @AppStore.State
  public reportYear!: number;

  @Watch("value") setValue(newValue: PreliminaryReportModel) {
    this.report = newValue;
  }

  created() {
    this.report = this.value;
  }

  touch(validator: any) {
    validator && validator.$touch && validator.$touch();
  }
}
